import type { SearchScenarioId } from 'owa-search-store';
import { action } from 'satcheljs';
import type { Suggestion } from 'owa-search-service/lib/data/schema/SuggestionSet';

/**
 * Action dispatched when a suggestion is selected from the SuggestionContextMenu.
 * Consuming client should have an orchestrator that subscribes to it that handles
 * each suggestion type.
 */
export interface SUGGESTION_SELECTEDActionMessage {
    suggestion: Suggestion;
    actionSource: string;
    scenarioId: SearchScenarioId;
    suggestionSetTraceId: string;
    index: number;
}
export const suggestionSelected: (
    suggestion: Suggestion,
    actionSource: string,
    scenarioId: SearchScenarioId,
    suggestionSetTraceId: string,
    index: number
) => SUGGESTION_SELECTEDActionMessage = action(
    'SUGGESTION_SELECTED',
    (
        suggestion: Suggestion,
        actionSource: string,
        scenarioId: SearchScenarioId,
        suggestionSetTraceId: string,
        index: number
    ): SUGGESTION_SELECTEDActionMessage => ({
        suggestion,
        actionSource,
        scenarioId,
        suggestionSetTraceId,
        index,
    })
);
